import React from 'react';
import { DocumentIcon } from '@/components/contextActions/icons';
import { HeaderIconButton } from '@/components/contextActions/common';
import {
  MedicalTemplateType,
  openTemplateDrawer,
  useCurrentHospitalCountry,
  useIsUsapHospital
} from '@/modules/appContext';
import { useAppDispatch, useCurrentPatientIdParam } from '@/hooks';

export const TemplateDrawerButton = () => {
  const dispatch = useAppDispatch();
  const patientId = useCurrentPatientIdParam();
  const enabled = useCurrentHospitalCountry() === 'US';
  const isUsapHospital = useIsUsapHospital();

  const openTemplates = () => {
    dispatch(
      openTemplateDrawer({
        patientId,
        templateType: MedicalTemplateType.PREOP_EVAL_PER_HOSPITAL,
        title: 'Preoperative Note Template',
        hideTemplateSelector: isUsapHospital
      })
    );
  };

  if (!enabled) {
    return null;
  }

  return (
    <HeaderIconButton
      disabled={!enabled}
      icon={<DocumentIcon />}
      onClick={openTemplates}
    />
  );
};
